import React from 'react';
import { Modal as BaseModal, ModalHeader } from 'reactstrap';
import { useModal } from '@ebay/nice-modal-react';
import { XCircle } from 'react-feather';

const Modal = ({
	children,
	title,
	id,
	icon,
	size = 'lg',
	customClass,
	backdrop = 'static',
	onCloseIcon,
	...other
}) => {
	const modal = useModal();
	let extraProps = { toggle: modal.visible ? modal.hide : modal.show };

	if (backdrop === 'static') {
		extraProps = { backdrop };
	}
	return (
		<BaseModal
			centered
			size={size}
			isOpen={modal.visible}
			{...extraProps}
			{...other}
		>
			<ModalHeader className={customClass ? customClass : 'modal-header-custom'}>
				{icon}
				{title}
				{onCloseIcon && (
					<div
						onClick={() => {
							modal.remove();
						}}
						style={{
							cursor: 'pointer',
							position: 'absolute',
							top: '0',
							paddingTop: '10px',
							right: 0,
							marginRight: '2.4rem',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center'
						}}
					>
						<XCircle color="#818181" size="2rem" />
					</div>
				)}
			</ModalHeader>
			{children}
		</BaseModal>
	);
};

export default Modal;
